module.exports = __webpack_public_path__ + "img/wallet.f3ec4412.png";